import { render, staticRenderFns } from "./qiming-resource.vue?vue&type=template&id=a85ff2e0&scoped=true"
import script from "./qiming-resource.vue?vue&type=script&lang=js"
export * from "./qiming-resource.vue?vue&type=script&lang=js"
import style0 from "./qiming-resource.vue?vue&type=style&index=0&id=a85ff2e0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85ff2e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a85ff2e0')) {
      api.createRecord('a85ff2e0', component.options)
    } else {
      api.reload('a85ff2e0', component.options)
    }
    module.hot.accept("./qiming-resource.vue?vue&type=template&id=a85ff2e0&scoped=true", function () {
      api.rerender('a85ff2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommended/qiming-resource.vue"
export default component.exports